import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function useLoginDetector (props?:any) {
  const navigate = useNavigate();
  const location = useLocation();
  const [search,setSearch] = useState({})
  useEffect(()=>{
    console.log('ssss',location)
    const searchParams = new URLSearchParams(location.search)
    const allSearchParams = Object?.fromEntries(searchParams.entries());
    // console.log('===search',allSearchParams)
    if(allSearchParams) {
      setSearch(allSearchParams)
    }
    const user = JSON.parse(localStorage.getItem('user')||'{}')
    const tokenInfo = JSON.parse(localStorage.getItem('tokenInfo')||'{}')
    if(tokenInfo&&tokenInfo.access_token) {
      // navigate(props?.to||'/operation');
    }else {
      let url = encodeURIComponent(window.location.href)
      navigate('/login?redirect='+url)
    }
  },[])
  return [search]
}
